import moment from 'moment';
import { DURATION_TYPE, PARTICIPANT_TYPE } from '../../CreateChallengePage/createChallengePageConstants';

export function durationTypeToDates(durationType) {
    let startDate = new Date();
    let endDate = new Date();
    switch (durationType) {
        default:
        case DURATION_TYPE.ONE_DAY:
        case DURATION_TYPE.CUSTOM: {
            startDate = moment()
                .startOf('day')
                .toDate();
            endDate = moment()
                .endOf('day')
                .toDate();
            break;
        }
        case DURATION_TYPE.WEEKEND: {
            const dateCursor = moment().endOf('isoWeek');
            endDate = dateCursor.toDate();
            dateCursor.add(-2, 'days').add(1, 'millisecond');
            startDate = dateCursor.toDate();
            break;
        }
        case DURATION_TYPE.WEEK: {
            const dateCursor = moment().startOf('day');
            startDate = dateCursor.toDate();
            dateCursor.add(6, 'day');
            endDate = dateCursor.endOf('day').toDate();
            break;
        }
        case DURATION_TYPE.MONTH: {
            const dateCursor = moment().startOf('month');
            startDate = dateCursor.toDate();
            endDate = dateCursor.endOf('month').toDate();
            break;
        }
    }
    return {
        startDate,
        endDate
    };
}

export function getLegalEndDate(participantType, durationType, startDate, endDate) {
    const momentStartDate = moment(startDate);
    switch (durationType) {
        default:
        case DURATION_TYPE.CUSTOM:
            const momentEndDate = moment(endDate);
            if (momentEndDate.isBefore(momentStartDate)) {
                endDate = momentStartDate.endOf('day').toDate();
            }
            if (participantType === PARTICIPANT_TYPE.GROUP) {
                momentStartDate.add(366, 'day');
            } else {
                momentStartDate.add(60, 'day');
            }
            if (momentEndDate.isAfter(momentStartDate)) {
                endDate = momentStartDate.endOf('day').toDate();
            }
            return endDate;
        case DURATION_TYPE.ONE_DAY:
            return momentStartDate.endOf('day').toDate();
        case DURATION_TYPE.WEEKEND:
            return momentStartDate.endOf('isoWeek').toDate();
        case DURATION_TYPE.WEEK:
            return momentStartDate
                .add(6, 'day')
                .endOf('day')
                .toDate();
        case DURATION_TYPE.MONTH:
            return momentStartDate.endOf('month').toDate();
    }
}
